<template>
  <div
    v-if="show"
    class="dev-ssbj"
  >
    <div class="dev-title-ssbj">
      <span class="dev-title-ssbj_test">实时报警</span>
    </div>
    <div
      v-show="dataList.length > 6"
      class="div-gd-kg"
      @click="handlGbgd()"
    >
      {{ gdIshowWz }}
    </div>
    <div
      class="div-body"
      :style="{ height: bodyHeight }"
    >
      <div style="height: 65px;">
        <span style="color: #ffffff00;">-</span>
      </div>
      <div class="table-container">
        <el-table
          ref="dataTable"
          :data="dataList"
          style="width: 96%; margin: 0px 10px 10px 20px;"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
          :height="tableHeight"
        >
          <el-table-column
            prop="sjlx"
            label="类型"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span :class="bgStr + scope.row.fxdjbm">{{ scope.row.sjlx }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sydw"
            label="消防责任单位"
            width="150"
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="jzwmc"
            label="所属楼栋"
            width="150"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ setName(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="azwz"
            label="安装位置"
            width="220"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="bjmc"
            label="设备名称"
            width="280"
            align="center"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="sjsj"
            label="时间"
            width="160"
            align="center"
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { monitorService } from '../monitor.service';

export default {
  name: 'Jrfxsssj',
  props: {
    activeJzw: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      gdIshow: true,
      gdIshowWz: '关闭滚动',
      bgStr: 'div-fxdj-bg_',
      dataList: [],
      show: false,
      queryInterval: null,
      scrollTimer: null,
      scrollDistance: 0,
      scrollSpeed: 1,
      scrollPaused: false
    };
  },
  computed: {
    // 在 computed 中添加
    tableHeight () {
      // 如果数据超过6条，设置一个固定高度，表头会自动固定
      return this.dataList.length > 6 ? '220px' : null;
    },
    bodyHeight () {
      const baseHeight = 113; // 表头+边距
      const rowHeight = 37; // 每行估算高度
      const maxHeight = 320; // 最大固定高度
      // 当数据超过6条时固定高度，否则自适应
      return this.dataList.length > 6
        ? `${maxHeight}px`
        : `${baseHeight + (this.dataList.length * rowHeight)}px`;
    }
  },
  methods: {
    setName (row) {
      const jzwmc = row.jzwmc ? row.jzwmc : '';
      const jzlc = row.jzlc ? row.jzlc + '楼' : '';
      if (!jzlc) {
        return jzwmc;
      }
      return jzwmc + '-' + jzlc;
    },
    /**
     * 设置表头样式
     */
    headerCellStyle () {
      return {
        background: '#0070FF',
        fontSize: '15px',
        color: '#3DFBFF',
        border: 'none',
        borderBottom: '1px solid rgba(61, 204, 255, 0.3)',
        height: '35px' // 增加表头高度
      };
    },
    /**
     * 设置单元格样式
     */
    cellStyle () {
      return {
        backgroundColor: 'transparent',
        fontSize: '15px',
        color: '#FFFFFF', // 表格内容字体颜色
        border: 'none',
        borderBottom: '1px solid rgba(61, 204, 255, 0.2)'
      };
    },
    /**
     * 查询实时报警数据
     */
    queryJrfxSJ () {
      const _this = this;
      monitorService.queryYxbgSssj()
        .then(res => {
          _this.dataList = res.data;
          if (_this.dataList.length > 0) {
            this.show = true;
          }

          // 遍历数组如果sjlx包含1则fxdjbm为one
          _this.dataList.forEach(item => {
            if (item.sjlx.includes('一级') || item.sjlx.includes('火')) {
              item.fxdjbm = 'one';
            } else if (item.sjlx.includes('二级')) {
              item.fxdjbm = 'two';
            } else if (item.sjlx.includes('三级')) {
              item.fxdjbm = 'three';
            };

            // // 如果cljg为已送达则sfsd为true
            if (item.cljg && item.cljg.includes('送达')) {
              item.sfsd = true;
              item.sfhc = false;
            } else {
              item.sfsd = false;
            };

            // sjsj 设置为 yyyy-MM-dd hh24:mi:ss格式
            item.sjsj = item.sjsj.substring(0, 19);
          });
        }).catch(error => {
          console.log('获取当前电气火灾设备信息失败！', error);
        }).finally(() => {
        });
    },
    handlGbgd () {
      this.gdIshow = !this.gdIshow;
      this.gdIshowWz = this.gdIshow ? '关闭滚动' : '开启滚动';
      // 根据滚动状态控制滚动行为
      if (this.gdIshow) {
        this.startScroll();
      } else {
        this.stopScroll();
      }
    },
    // 开始滚动
    startScroll () {
      if (this.dataList.length <= 6) return;
      // 清除之前的定时器
      this.stopScroll();
      this.scrollTimer = setInterval(() => {
        // 添加引用存在性检查
        if (!this.$refs.dataTable) return;
        const tableBody = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper');
        if (!tableBody) return;
        const maxScroll = tableBody.scrollHeight - tableBody.clientHeight;
        // 如果已经滚到底部，则重置到顶部
        if (this.scrollDistance >= maxScroll) {
          this.scrollDistance = 0;
          tableBody.scrollTop = 0;
        } else {
          // 否则继续滚动
          this.scrollDistance += this.scrollSpeed;
          tableBody.scrollTop = this.scrollDistance;
        }
      }, 80);
    },
    // 停止滚动
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    // 重置滚动位置
    resetScroll () {
      this.scrollDistance = 0;
      // 添加引用存在性检查
      if (!this.$refs.dataTable) return;
      const tableBody = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper');
      if (tableBody) {
        tableBody.scrollTop = 0;
      }
    }
  },
  watch: {
    dataList: {
      handler (newVal) {
        if (newVal.length > 6 && this.gdIshow) {
          this.$nextTick(() => {
            this.resetScroll();
            this.startScroll();
          });
        } else {
          this.stopScroll();
        }
      },
      deep: true
    },
    activeJzw (newVal, oldVal) {
      if (newVal) {
        this.show = false;
        // 当组件隐藏时停止滚动
        this.stopScroll();
        if (this.queryInterval) {
          clearInterval(this.queryInterval);
          this.queryInterval = null;
        }
      } else {
        // 重新滚动
        this.startScroll();
        this.show = true;
      }
    }
  },
  beforeDestroy () {
    this.stopScroll();
    if (this.queryInterval) {
      clearInterval(this.queryInterval);
      this.queryInterval = null;
    }
  },
  mounted () {
    const _this = this;
    _this.queryJrfxSJ();

    this.queryInterval = setInterval(() => {
      _this.queryJrfxSJ();
    }, 5000);

    // 在初始挂载后检查是否需要开始滚动
    this.$nextTick(() => {
      if (this.dataList.length > 6 && this.gdIshow) {
        this.startScroll();
      }
    });
  }
};
</script>

<style lang="less">
.dev-ssbj {
  position: relative;
  display: flex;          /* 新增 */
  flex-direction: column; /* 竖排布局 */
}

.div-gd-kg {
  width: 56px;
  padding: 4px;
  border-radius: 2px;
  color: #fff;
  position: absolute;
  background: url('/images/newscreen/bg/关闭滚动.png') no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  right: 10px;
  margin-top: 44px;
  margin-right: 20px;
}

.dev-title-ssbj {
  display: flex;
  align-items: center;
  position: relative;
  top: 54px;
  left: 10px;
  width: 97%;
  height: 30px;
  background: url('/images/newscreen/bg/实时报警标题.png');
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;

  &_test {
    margin-top: -7px;
    margin-left: 25px;
    font-family: HYYaKuHei-85J;
    font-weight: 85J;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.div-body {
  overflow: hidden;
  background: url('/images/newscreen/bg/实时报警.png') no-repeat;
  background-size: 100% 100%;
}

/* 保留原有的风险等级颜色 */
.div-fxdj-bg_one { color: red; }
.div-fxdj-bg_two { color: #f0751e; }
.div-fxdj-bg_three { color: #fbe714; }

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}

.div-item_img {
  margin: 0 10px;
}

.div-right {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0px;
}

.div-azwz {
  display: flex;
  align-items: center;
  margin: 20px;
}

/* 新增表格容器样式 */
.table-container {
  overflow-y: auto;
  max-height: calc(100% - 70px); /* 减去头部空间 */
}

/* 表格样式定制 */
.el-table {
  background-color: transparent !important;
  &::before {
    height: 0 !important; // 去掉表格底部线条
  }

  /* 去除表格背景颜色和边框 */
  tr, th, td {
    background-color: transparent !important;
  }

  /* 自定义分割线 */
  .el-table__row {
    td {
      border-top: none;
      border-right: none;
      border-left: none;
      height: 35px !important; /* 增加行高 */
      padding: 8px 0 !important; /* 调整单元格内边距 */
    }
  }

  /* 鼠标悬停效果 */
  .el-table__row:hover > td {
    background-color: rgba(61, 204, 255, 0.1) !important;
  }

}

/* 确保 el-table 内部滚动条也隐藏 */
.table-container .el-table__body-wrapper::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

.table-container .el-table__body-wrapper {
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}

</style>
